import React from "react";
import { useNavigate } from "react-router-dom";

import { SmartRoofOwesReportItem, invoiceTypeToText } from "../../../../models";

export interface InvoiceItemProps {
  invoice: SmartRoofOwesReportItem;
  isSelected: boolean;
  onSelect: (invoiceId: string, isSelected: boolean) => void;
}

export const InvoiceItem: React.FC<InvoiceItemProps> = ({
  invoice,
  isSelected,
  onSelect,
}) => {
  const navigate = useNavigate();

  const onViewOrderClick = () => navigate(`/orders/${invoice.orderId}`);

  const handleCheckboxChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    onSelect(invoice.invoiceId, e.target.checked);
  };

  return (
    <div
      className={`invoice-container ${isSelected ? "selected" : ""}`}
      key={invoice.invoiceId}
    >
      <label className="checkbox-container">
        <input
          type="checkbox"
          checked={isSelected}
          onChange={handleCheckboxChange}
        />
        <span className="checkmark"></span>
      </label>

      <div className="info-container">
        <div className="info-item width-240">
          <div className="info-label">Name:</div>
          <div className="info-value">{invoice.name}</div>
        </div>

        <div className="info-item">
          <div className="info-label">Order ID:</div>
          <div className="info-value">{invoice.orderId}</div>
        </div>

        <div className="info-item">
          <div className="info-label">Type:</div>
          <div className="info-value">{invoiceTypeToText[invoice.type]}</div>
        </div>

        <div className="info-item width-120">
          <div className="info-label">Total:</div>
          <div className="info-value">{`$${invoice.total.toFixed(2)}`}</div>
        </div>

        <div className="info-item">
          <div className="info-label">Date:</div>
          <div className="info-value">{`${invoice.date}`}</div>
        </div>

        <div className="info-item width-300">
          <div className="info-label">Address:</div>
          <div className="info-value">{`${invoice.address}`}</div>
        </div>

        <div className="view-order-button" onClick={onViewOrderClick}>
          View order
        </div>
      </div>
    </div>
  );
};
